const question1 = {
    'question': 'Jak wygląda psychoterapia rodzinna?',
    'answer': 'Psychoterapia rodzinna to forma psychoterapii, która koncentruje się na relacjach rodzinnych. Celem terapii rodzinnej jest poprawa komunikacji i relacji między członkami rodziny, a także pomoc w rozwiązaniu problemów, z którymi boryka się rodzina.',
}

export default question1;